export default "__VITE_ASSET__Bgne934Y__"